// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#header-logo{margin-left:8em;width:600px}@media (max-width:1064px){#header-logo{margin-left:0}}#header-logo-right{width:250px;margin-right:30px}@media (max-width:1064px){#header-logo-right{margin-right:0}}.inner-header{transition:padding .2s cubic-bezier(.4,0,.2,1);border-top:4px solid var(--color-secondary)}.inner-header:after{content:\" \";height:2px;top:0}.bottom-bar,.inner-header:after{position:absolute;left:0;right:0}.bottom-bar{width:100%;background:var(--color-primary);z-index:1;top:100px;height:7px}.bottom-bar:after{content:\" \";background:#96ff73;height:2px;position:absolute;top:0;left:0;right:0}", ""]);
// Exports
exports.locals = {
	"primaryColor": "#007a59",
	"primaryLightColor": "#1cb9fd",
	"secondaryColor": "#fdba12",
	"accentColor": "#96ff73",
	"textColor": "#333"
};
module.exports = exports;
